<div
  [ngStyle]="horizontalAlignStyles"
  class="image-container"
>
  @if (src && mainImageValid) {
    <img
      [alt]="alt ? alt : ''"
      [ngStyle]="verticalAlignStyles"
      [src]="src"
      (error)="mainImageValid = false"
      class="image"
    >
  }
  @if (alternative && alternativeImageValid) {
    <img
      [alt]="alt ? alt : ''"
      [ngStyle]="verticalAlignStyles"
      [src]="alternative"
      (error)="alternativeImageValid = false"
      class="image"
    >
  }
</div>
